import { render } from "./Awards.vue?vue&type=template&id=192eea40&ts=true"
import script from "./Awards.vue?vue&type=script&lang=ts"
export * from "./Awards.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__